import PastOrdersScreen, { PAST_ORDERS_SCREEN_ROUTE } from '../screens/PastOrdersScreen';
import FavouritesScreen, { FAVOURITES_SCREEN_ROUTE } from '../screens/FavouritesScreen';
import InitialScreen, { INITIAL_SCREEN_ROUTE } from '../screens/InitialScreen';
import CompletedOrderScreen, {
  COMPLETED_ORDER_SCREEN_ROUTE,
} from '../screens/CompletedOrderScreen';
import MenuScreen, { MENU_SCREEN_ROUTE } from '../screens/MenuScreen';
import ReviewOrderScreen, { REVIEW_ORDER_SCREEN_ROUTE } from '../screens/ReviewOrderScreen';
import RewardsScreen, { REWARDS_SCREEN_ROUTE } from '../screens/RewardsScreen';
import ReplaceCardScreen, { REPLACE_CARD_ROUTE } from '../screens/ReplaceCardScreen';
import ClaimMissingPointsScreen, {
  CLAIM_MISSING_POINTS_ROUTE,
} from '../screens/ClaimMissingPointsScreen';
import OffersScreen, { OFFERS_ROUTE } from '../screens/OffersScreen';
import ProfileScreen, { PROFILE_ROUTE } from '../screens/ProfileScreen';
import PurchaseGiftCardScreen, {
  PURCHASE_GIFT_CARD_ROUTE,
} from '../screens/PurchaseGiftCardScreen';
import UpdatePasswordScreen, { UPDATE_PASSWORD_ROUTE } from '../screens/UpdatePasswordScreen';
import NewPasswordScreen, { NEW_PASSWORD_ROUTE } from '../screens/NewPasswordScreen';
import VerifyAccountScreen, { VERIFY_ACCOUNT_ROUTE } from '../screens/VerifyAccountScreen';
import DeleteAccountScreen, { DELETE_ACCOUNT_ROUTE } from '../screens/DeleteAccountScreen';
import GiftCardCheckBalanceScreen, {
  CHECK_BALANCE_ROUTE,
} from '../screens/GiftCardCheckBalanceScreen';
import GiftCardTopUp, { GIFT_CARD_TOP_UP_ROUTE } from '../screens/GiftCardTopUp';
import AddLoyaltyWalletScreen, {
  ADD_LOYALTY_WALLET_ROUTE,
} from '../screens/AddLoyaltyWalletScreen';
import MemberMoneyScreen, { MEMBER_MONEY_ROUTE } from '../screens/MemberMoneyScreen';
import TransactionsScreen, { TRANSACTIONS_SCREEN } from '../screens/TransactionsScreen';
import RegistrationVerifyScreen, { REGISTRATION_VERIFY } from '../screens/RegistrationVerify';
import { store } from '../store';
import SignInScreen, { SIGN_IN_ROUTE } from '../screens/SignInScreen';

export const giftcardRoutes = [
  PURCHASE_GIFT_CARD_ROUTE,
  CHECK_BALANCE_ROUTE,
  GIFT_CARD_TOP_UP_ROUTE,
  ADD_LOYALTY_WALLET_ROUTE,
];

export const profileRoutesPath = [PROFILE_ROUTE, UPDATE_PASSWORD_ROUTE, DELETE_ACCOUNT_ROUTE];

export const menu: DropdownModalMenu[] = [
  {
    label: 'button.giftCard',
    path: PURCHASE_GIFT_CARD_ROUTE,
    title: 'giftCardHeader',
    subTitle: 'purchaseGiftCard',
    private: false,
    subRoutes: [
      {
        label: 'purchaseGiftCard',
        path: PURCHASE_GIFT_CARD_ROUTE,
        title: 'giftCardHeader',
        subTitle: 'purchaseGiftCard',
      },
      {
        label: 'checkBalance',
        path: CHECK_BALANCE_ROUTE,
        title: 'giftCardHeader',
        subTitle: 'checkBalance',
      },
      {
        label: 'giftCardTopUp',
        path: GIFT_CARD_TOP_UP_ROUTE,
        title: 'giftCardHeader',
        subTitle: 'giftCardTopUp',
      },
      {
        label: 'addLoyaltyWallet',
        path: ADD_LOYALTY_WALLET_ROUTE,
        title: 'giftCardHeader',
        subTitle: 'addLoyaltyWallet',
      },
    ],
  },
  {
    label: 'button.profile',
    path: PROFILE_ROUTE,
    title: 'profileHeader',
    private: true,
    subRoutes: [
      {
        label: 'profileDetails',
        path: PROFILE_ROUTE,
        title: 'profileHeader',
      },
      {
        label: 'updatePassword',
        path: UPDATE_PASSWORD_ROUTE,
        title: 'updatePassword',
      },
      {
        label: 'deleteAccount',
        path: DELETE_ACCOUNT_ROUTE,
        title: 'deleteAccount',
      },
    ],
  },
];

export const loyaltyMenu: DropdownModalMenu[] = [
  {
    label: 'button.rewards',
    path: REWARDS_SCREEN_ROUTE,
    private: true,
  },
  {
    label: 'button.offers',
    path: OFFERS_ROUTE,
    title: 'offersHeader',
    private: true,
  },
  {
    label: 'button.profile',
    path: PROFILE_ROUTE,
    title: 'profileHeader',
    private: true,
    subRoutes: [
      {
        label: 'profileDetails',
        path: PROFILE_ROUTE,
        title: 'profileHeader',
      },
      {
        label: 'updatePassword',
        path: UPDATE_PASSWORD_ROUTE,
        title: 'updatePassword',
      },
      {
        label: 'deleteAccount',
        path: DELETE_ACCOUNT_ROUTE,
        title: 'deleteAccount',
      },
    ],
  },
  {
    label: 'button.giftCard',
    path: PURCHASE_GIFT_CARD_ROUTE,
    title: 'giftCardHeader',
    subTitle: 'purchaseGiftCard',
    private: false,
    subRoutes: [
      {
        label: 'purchaseGiftCard',
        path: PURCHASE_GIFT_CARD_ROUTE,
        title: 'giftCardHeader',
        subTitle: 'purchaseGiftCard',
      },
      {
        label: 'checkBalance',
        path: CHECK_BALANCE_ROUTE,
        title: 'giftCardHeader',
        subTitle: 'checkBalance',
      },
      {
        label: 'giftCardTopUp',
        path: GIFT_CARD_TOP_UP_ROUTE,
        title: 'giftCardHeader',
        subTitle: 'giftCardTopUp',
      },
      {
        label: 'addLoyaltyWallet',
        path: ADD_LOYALTY_WALLET_ROUTE,
        title: 'giftCardHeader',
        subTitle: 'addLoyaltyWallet',
      },
    ],
  },
  {
    label: 'memberMoneyHeader',
    path: MEMBER_MONEY_ROUTE,
    title: 'memberMoneyHeader',
    subTitle: 'button.topupButton',
    private: true,
  },
  {
    label: 'button.favouriteOrders',
    path: FAVOURITES_SCREEN_ROUTE,
    title: 'favouriteOrdersHeader',
    private: true,
  },
  {
    label: 'button.pastOrdersMemberButton',
    path: PAST_ORDERS_SCREEN_ROUTE,
    private: true,
  },
  {
    label: 'button.transactions',
    path: TRANSACTIONS_SCREEN,
    private: true,
    title: 'transactionsHeader',
  },
  {
    label: 'button.claimMissingPoints',
    path: CLAIM_MISSING_POINTS_ROUTE,
    title: 'claimMissingPointsHeader',
    private: true,
  },
  {
    label: 'button.replaceCard',
    path: REPLACE_CARD_ROUTE,
    title: 'replaceCardHeader',
    private: true,
  },
];

const loyaltyOnlyRoutes: Routes[] = [
  {
    path: INITIAL_SCREEN_ROUTE,
    exact: true,
    component: SignInScreen,
    private: false,
  },
  {
    path: SIGN_IN_ROUTE,
    exact: true,
    component: SignInScreen,
    private: false,
  },
  {
    path: NEW_PASSWORD_ROUTE,
    exact: false,
    component: NewPasswordScreen,
    private: false,
  },
  {
    path: VERIFY_ACCOUNT_ROUTE,
    exact: false,
    component: VerifyAccountScreen,
    private: false,
  },
];

const orderingRoutes: Routes[] = [
  {
    path: INITIAL_SCREEN_ROUTE,
    exact: true,
    component: InitialScreen,
    private: false,
  },
  {
    path: COMPLETED_ORDER_SCREEN_ROUTE,
    exact: false,
    component: CompletedOrderScreen,
    private: false,
  },
  {
    path: MENU_SCREEN_ROUTE,
    exact: false,
    component: MenuScreen,
    private: false,
  },
  {
    path: REVIEW_ORDER_SCREEN_ROUTE,
    exact: false,
    component: ReviewOrderScreen,
    private: false,
  },
  {
    path: NEW_PASSWORD_ROUTE,
    exact: false,
    component: NewPasswordScreen,
    private: false,
  },
  {
    path: VERIFY_ACCOUNT_ROUTE,
    exact: false,
    component: VerifyAccountScreen,
    private: false,
  },
  {
    path: REGISTRATION_VERIFY,
    exact: false,
    component: RegistrationVerifyScreen,
    private: true,
  },
];

const loyaltyRoutes: Routes[] = [
  {
    path: FAVOURITES_SCREEN_ROUTE,
    exact: false,
    component: FavouritesScreen,
    private: true,
  },
  {
    path: PAST_ORDERS_SCREEN_ROUTE,
    exact: false,
    component: PastOrdersScreen,
    private: true,
  },

  {
    path: MEMBER_MONEY_ROUTE,
    exact: false,
    component: MemberMoneyScreen,
    private: true,
  },
  {
    path: OFFERS_ROUTE,
    exact: false,
    component: OffersScreen,
    private: true,
  },
  {
    path: PROFILE_ROUTE,
    exact: false,
    component: ProfileScreen,
    private: true,
  },
  {
    path: UPDATE_PASSWORD_ROUTE,
    exact: false,
    component: UpdatePasswordScreen,
    private: true,
  },
  {
    path: DELETE_ACCOUNT_ROUTE,
    exact: false,
    component: DeleteAccountScreen,
    private: true,
  },
  {
    path: REPLACE_CARD_ROUTE,
    exact: false,
    component: ReplaceCardScreen,
    private: true,
  },
  {
    path: CLAIM_MISSING_POINTS_ROUTE,
    exact: false,
    component: ClaimMissingPointsScreen,
    private: true,
  },
  {
    path: REWARDS_SCREEN_ROUTE,
    exact: false,
    component: RewardsScreen,
    private: true,
  },
  {
    path: TRANSACTIONS_SCREEN,
    exact: false,
    component: TransactionsScreen,
    private: true,
  },
];

const giftCardRoutes: Routes[] = [
  {
    path: GIFT_CARD_TOP_UP_ROUTE,
    exact: false,
    component: GiftCardTopUp,
    private: false,
    useWrapper: true,
  },
  {
    path: ADD_LOYALTY_WALLET_ROUTE,
    exact: false,
    component: AddLoyaltyWalletScreen,
    private: false,
    useWrapper: true,
  },
  {
    path: PURCHASE_GIFT_CARD_ROUTE,
    exact: false,
    component: PurchaseGiftCardScreen,
    private: false,
    useWrapper: true,
  },
  {
    path: CHECK_BALANCE_ROUTE,
    exact: false,
    component: GiftCardCheckBalanceScreen,
    private: false,
    useWrapper: true,
  },
];

const profileRoutes: Routes[] = [
  {
    path: PROFILE_ROUTE,
    exact: false,
    component: ProfileScreen,
    private: true,
    useWrapper: true,
  },
  {
    path: UPDATE_PASSWORD_ROUTE,
    exact: false,
    component: UpdatePasswordScreen,
    private: true,
    useWrapper: true,
  },
  {
    path: DELETE_ACCOUNT_ROUTE,
    exact: false,
    component: DeleteAccountScreen,
    private: true,
    useWrapper: true,
  },
];

export const getDefaultDropdownMenu = () => {
  const isGiftcardPurchaseEnabled = store.getState().config.enableGiftcardPurchase;
  const disabledRoutes = isGiftcardPurchaseEnabled ? [] : [PURCHASE_GIFT_CARD_ROUTE];
  const isWalletEnabled = store.getState().config.enableLoyaltyWallet;

  return isGiftcardPurchaseEnabled
    ? isWalletEnabled
      ? menu
      : menu.map(item => {
          if (item.subRoutes) {
            item.subRoutes = item.subRoutes?.filter(
              route => route.path !== ADD_LOYALTY_WALLET_ROUTE,
            );
          }
          return item;
        })
    : menu.filter(item => !disabledRoutes.includes(item.path));
};

export const getLoyaltyDropdownMenu = () => {
  const disabledLoyaltyRoutes = store.getState().config.disabledLoyaltyRoutes;
  const isGiftcardPurchaseEnabled = store.getState().config.enableGiftcardPurchase;
  const isMemberVerified =
    !!store.getState().profile?.verificationDate ||
    !store.getState().config.loyaltyRequiresVerification;
  const onlyGiftcardPurchasesEnabled = store.getState().config.enableOnlyGiftcardPurchases;

  const disabledRoutes = !isMemberVerified
    ? isGiftcardPurchaseEnabled
      ? [MEMBER_MONEY_ROUTE]
      : [MEMBER_MONEY_ROUTE, PURCHASE_GIFT_CARD_ROUTE]
    : isGiftcardPurchaseEnabled
    ? []
    : [PURCHASE_GIFT_CARD_ROUTE];

  const isWalletEnabled = store.getState().config.enableLoyaltyWallet;
  const isSelfDeleteEnabled = store.getState().config.enableSelfDelete;

  return loyaltyMenu
    .filter(menu => !disabledLoyaltyRoutes?.includes(menu.path))
    .filter(menu => !disabledRoutes?.includes(menu.path))
    .map(menu => {
      if (!isWalletEnabled && menu.subRoutes) {
        menu.subRoutes = menu.subRoutes?.filter(route => route.path !== ADD_LOYALTY_WALLET_ROUTE);
      }
      if (!isSelfDeleteEnabled && menu.subRoutes) {
        menu.subRoutes = menu.subRoutes?.filter(route => route.path !== DELETE_ACCOUNT_ROUTE);
      }

      return menu;
    });
};

export const getAvailableRoutes = () => {
  return {
    loyaltyOnlyRoutes,
    orderingRoutes,
    loyaltyRoutes,
    giftCardRoutes,
    profileRoutes,
  };
};
